import { useCallback } from 'react'
import { Play, Pause, SkipBack, SkipForward, X, Rewind } from 'lucide-react'

export default function PlaybackControls({
  isPlayback,
  isSupported,
  isPlaying,
  currentIndex,
  totalBars,
  speed,
  onEnter,
  onExit,
  onPlay,
  onPause,
  onStepBack,
  onStepForward,
  onSeek,
  onSpeedChange,
}) {
  const progress = totalBars > 0 ? (currentIndex / (totalBars - 1)) * 100 : 0

  const handleSeek = useCallback((e) => {
    const pct = Number(e.target.value)
    const index = Math.round((pct / 100) * (totalBars - 1))
    onSeek(index)
  }, [totalBars, onSeek])

  if (!isPlayback) {
    return (
      <button
        onClick={onEnter}
        disabled={!isSupported}
        title={isSupported ? "Reproducir histórico precalculado (90 días)" : `Solo para ${[...new Set(['15m','1h','4h'])].join('/')}`}
        className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold rounded-lg border transition-colors shadow-sm ${
          isSupported
            ? 'bg-blue-50 dark:bg-blue-900/30 border-blue-200 dark:border-blue-700 text-blue-700 dark:text-blue-300 hover:bg-blue-100 dark:hover:bg-blue-900/50'
            : 'bg-slate-100 dark:bg-gray-800 border-slate-200 dark:border-gray-700 text-slate-400 dark:text-gray-500 cursor-not-allowed'
        }`}
      >
        <Rewind size={14} />
        <span>Playback</span>
      </button>
    )
  }

  return (
    <div className="flex items-center gap-2 px-2.5 py-1.5 bg-white dark:bg-gray-800 border border-slate-200 dark:border-gray-700 rounded-lg">
      <button onClick={onExit} title="Salir" className="text-slate-400 hover:text-red-500">
        <X size={13} />
      </button>

      <button
        onClick={isPlaying ? onPause : onPlay}
        title={isPlaying ? 'Pausar' : 'Reproducir'}
        className="text-slate-700 dark:text-gray-200 hover:text-blue-600 dark:hover:text-blue-400"
      >
        {isPlaying ? <Pause size={14} /> : <Play size={14} />}
      </button>

      <button onClick={() => onStepBack(1)} title="-1 barra" className="text-slate-500 hover:text-slate-700 dark:hover:text-gray-200">
        <SkipBack size={14} />
      </button>
      <button onClick={() => onStepForward(1)} title="+1 barra" className="text-slate-500 hover:text-slate-700 dark:hover:text-gray-200">
        <SkipForward size={14} />
      </button>

      <div className="flex items-center gap-1.5 min-w-[120px]">
        <input
          type="range"
          min={0}
          max={100}
          step={0.1}
          value={progress}
          onChange={handleSeek}
          className="w-full h-1 bg-slate-200 dark:bg-gray-700 rounded-lg appearance-none cursor-pointer accent-blue-500"
        />
      </div>

      <span className="text-[10px] font-mono text-slate-500 dark:text-gray-400 whitespace-nowrap">
        {currentIndex + 1}/{totalBars}
      </span>

      <select
        value={speed}
        onChange={(e) => onSpeedChange(Number(e.target.value))}
        className="text-[10px] bg-slate-50 dark:bg-gray-900 border border-slate-200 dark:border-gray-700 rounded px-1 py-0.5 text-slate-700 dark:text-gray-300"
      >
        <option value={0.5}>0.5x</option>
        <option value={1}>1x</option>
        <option value={2}>2x</option>
        <option value={5}>5x</option>
        <option value={10}>10x</option>
      </select>
    </div>
  )
}
